<template>
<div>
  <div class="form-row">
      <h3>Manage Product Prices</h3>
    </div>
  <div class="e-card">
    <div id="permitTab" style="display: none">
      <div>
        <ejs-button
          type="button"
          cssClass="e-info"
          v-on:click.native="onNewPermitPriceClick"
        >
          <font-awesome-icon :icon="['fas', 'plus']" style="display: inline" />
          New Permit Price
        </ejs-button>
      </div>
      <ejs-grid
        :dataSource="PermitPrices()"
        ref="refPermitPrices"
        :selection-settings="selectionOptions"
        :allowSorting="true"
        :allowPaging="true"
        :pageSettings="pageSettings"
        :commandClick="cmdPermitClick"
        :rowDataBound="rowPriceDataBound"
      >
        <e-columns>
          <e-column
            headerText="Edit"
            :commands="commands"
            textAlign="Right"
            width="10%"
          ></e-column>
          <e-column
            field="price.priceId"
            headerText="Price ID"
            textAlign="Left"
            :isPrimaryKey="true"
            width="0"
          ></e-column>
          <e-column
            field="productDescription"
            headerText="Product Description"
            textAlign="Left"
            width="18%"
          ></e-column>
          <e-column
            field="price.amountApp"
            headerText="Per Application"
            textAlign="Left"
            width="15%"
            format="C2"
          ></e-column>
          <e-column
            field="price.amountTank"
            headerText="Per Tank"
            textAlign="Left"
            width="15%"
            format="C2"
          ></e-column>
          <e-column
            field="price.amountLevy"
            headerText="Levy"
            textAlign="Left"
            width="10%"
            format="C2"
          ></e-column>
          <e-column
            field="price.chargeBy"
            headerText="Charge By"
            textAlign="Left"
            width="15%"
          ></e-column>
          <e-column
            field="price.effectiveStartDate"
            headerText="Start Date"
            textAlign="Left"
            width="15%"
            type="date"
            format="MMM dd, yyyy"
          ></e-column>
          <e-column
            field="price.effectiveEndDate"
            headerText="End Date"
            textAlign="Left"
            width="15%"
            type="date"
            format="MMM dd, yyyy"
          ></e-column>
        </e-columns>
      </ejs-grid>
      <div v-if="dataIsNotReady()">Loading Data.....</div>
    </div>
    <div id="operationalTab" style="display: none">
      <!-- <ejs-grid ref='operationalGrid' :dataSource='OperationalPrices(1)' height='265px'>
        <e-columns>
            <e-column field='registrationDesc' headerText='Registration Period'
            textAlign='Center' width=200></e-column>
            <e-column field='label' headerText='Months'
            textAlign='Center' width=120></e-column>
            <e-column field='value' headerText='Fee'
            textAlign='Center' width=120 format='C2'></e-column>
            <e-column field='levy' headerText='Levy'
            textAlign='Center' width=120 format='C2'></e-column>
        </e-columns>
      </ejs-grid>
      <hr/> -->
      <div>
      <ejs-grid
        ref="operationalGrid"
        :dataSource="OperationalPrices(0)"
        height="265px"
      >
        <e-columns>
          <e-column
            field="opYear"
            headerText="Operating Year"
            textAlign="Center"
            width="80"
          ></e-column>
          <e-column
            field="registrationDesc"
            headerText="Registration Period"
            textAlign="Center"
            width="200"
          ></e-column>
          <e-column
            field="label"
            headerText="Months"
            textAlign="Center"
            width="120"
          ></e-column>
          <e-column
            field="value"
            headerText="Fee"
            textAlign="Center"
            width="120"
            format="C2"
          ></e-column>
          <e-column
            field="levy"
            headerText="Levy"
            textAlign="Center"
            width="120"
            format="C2"
          ></e-column>
        </e-columns>
      </ejs-grid>
      </div>
      <div v-show="OperationalPrices(1)"><br/>
        <ejs-grid
        ref="operationalGrid"
        :dataSource="OperationalPrices(1)"
        height="265px"
      >
        <e-columns>
          <e-column
            field="opYear"
            headerText="Operating Year"
            textAlign="Center"
            width="80"
          ></e-column>
          <e-column
            field="registrationDesc"
            headerText="Registration Period"
            textAlign="Center"
            width="200"
          ></e-column>
          <e-column
            field="label"
            headerText="Months"
            textAlign="Center"
            width="120"
          ></e-column>
          <e-column
            field="value"
            headerText="Fee"
            textAlign="Center"
            width="120"
            format="C2"
          ></e-column>
          <e-column
            field="levy"
            headerText="Levy"
            textAlign="Center"
            width="120"
            format="C2"
          ></e-column>
        </e-columns>
      </ejs-grid>
      </div>
    </div>
    <div id="searchrequestTab" style="display: none">
      <div style="text-align: left; padding: 1px">
        <ejs-button
          type="button"
          cssClass="e-info"
          v-on:click.native="onNewSearchRequestPriceClick"
        >
          <font-awesome-icon :icon="['fas', 'plus']" style="display: inline" />
          New Search Request Price
        </ejs-button>
      </div>
      <ejs-grid
        :dataSource="SearchRequestPrices()"
        ref="refSearchRequestPrices"
        :selection-settings="selectionOptions"
        :allowSorting="true"
        :allowPaging="true"
        :pageSettings="pageSettings"
        :commandClick="cmdSearchRequestClick"
        :rowDataBound="rowPriceDataBound"
      >
        <e-columns>
          <e-column
            headerText="Edit"
            :commands="commands"
            textAlign="left"
            width="90"
          ></e-column>
          <e-column
            field="price.priceId"
            headerText="Price ID"
            textAlign="Left"
            :isPrimaryKey="true"
            width="0"
          ></e-column>
          <e-column
            field="productDescription"
            headerText="Product Description"
            textAlign="center"
            width="180"
          ></e-column>
          <e-column
            field="price.amountPerAddress"
            headerText="Per Address"
            textAlign="Left"
            width="140"
            format="C2"
          ></e-column>
          <e-column
            field="amountLevy2"
            headerText="Levy"
            textAlign="Left"
            width="100"
          ></e-column>
          <!-- <e-column field="price.levyFeeType" headerText="Levy Charge Type"
              textAlign="Left" width=180 format='C2'></e-column> -->
          <e-column
            field="price.chargeBy"
            headerText="Charge By"
            textAlign="Left"
            width="140"
          ></e-column>
          <e-column
            field="price.effectiveStartDate"
            headerText="Start Date"
            textAlign="Left"
            width="120"
            type="date"
            format="MMM dd, yyyy"
          ></e-column>
          <e-column
            field="price.effectiveEndDate"
            headerText="End Date"
            textAlign="Left"
            width="120"
            type="date"
            format="MMM dd, yyyy"
          ></e-column>
        </e-columns>
      </ejs-grid>
    </div>
    <div id="miscellaneousTab" style="display: none">
      <div style="text-align: left; padding: 1px">
        <ejs-button
          type="button"
          cssClass="e-info"
          v-on:click.native="onNewMiscellaneousPriceClick"
        >
          <font-awesome-icon :icon="['fas', 'plus']" style="display: inline" />
          New Miscellaneous Price
        </ejs-button>
      </div>
      <ejs-grid
        :dataSource="MiscellaneousPrices()"
        ref="refMiscellaneousPrices"
        :selection-settings="selectionOptions"
        :allowSorting="true"
        :allowPaging="true"
        :pageSettings="pageSettings"
        :commandClick="cmdMiscellaneousClick"
        :rowDataBound="rowPriceDataBound"
      >
        <e-columns>
          <e-column
            headerText="Edit"
            :commands="commands"
            textAlign="left"
            width="90"
          ></e-column>
          <e-column
            field="price.priceId"
            headerText="Price ID"
            textAlign="Left"
            :isPrimaryKey="true"
            width="0"
          ></e-column>
          <e-column
            field="productDescription"
            headerText="Product Description"
            textAlign="Left"
            width="240"
            clipMode="EllipsisWithTooltip"
          ></e-column>
          <e-column
            field="amountLabel2"
            headerText="Amount"
            textAlign="Left"
            width="15%"
            format="C2"
          ></e-column>
          <!-- <e-column
            field="price.amountTank"
            headerText="Per Tank"
            textAlign="Left"
            width="15%"
            format="C2"
          ></e-column> -->
          <e-column
            field="price.amountLevy"
            headerText="Levy"
            textAlign="Left"
            width="10%"
            format="C2"
          ></e-column>
          <!-- <e-column
            field="price.amountPerAddress"
            headerText="Per Address"
            textAlign="Left"
            width="140"
            format="C2"
          ></e-column> -->
          <e-column
            field="price.chargeBy"
            headerText="Charge By"
            textAlign="Left"
            width="15%"
          ></e-column>
          <e-column
            field="price.effectiveStartDate"
            headerText="Start Date"
            textAlign="Left"
            width="120"
            type="date"
            format="MMM dd, yyyy"
          ></e-column>
          <e-column
            field="price.effectiveEndDate"
            headerText="End Date"
            textAlign="Left"
            width="120"
            type="date"
            format="MMM dd, yyyy"
          ></e-column>
        </e-columns>
      </ejs-grid>
    </div>
    <div id="historicalTab" style="display: none">
      <ejs-grid
        :dataSource="HistoricalPrices()"
        ref="refHistoricalPrices"
        :selection-settings="selectionOptions"
        :allowSorting="true"
        :allowPaging="true"
        :pageSettings="pageSettings"
      >
        <e-columns>
          <e-column
            field="productId"
            headerText="Product ID"
            textAlign="Left"
            :isPrimaryKey="true"
            width="0"
          ></e-column>
          <e-column
            field="productDescription"
            headerText="Product Description"
            textAlign="Left"
            width="240"
          ></e-column>
          <e-column
            field="pricechangeLog.amountApp"
            headerText="Per Application"
            textAlign="Left"
            width="140"
            format="C2"
          ></e-column>
          <e-column
            field="pricechangeLog.amountTank"
            headerText="Per Tank"
            textAlign="Left"
            width="120"
            format="C2"
          ></e-column>
          <e-column
            field="pricechangeLog.amountLevy"
            headerText="Levy"
            textAlign="Left"
            width="100"
            format="C2"
          ></e-column>
          <e-column
            field="pricechangeLog.amountPerAddress"
            headerText="Per Address"
            textAlign="Left"
            width="140"
            format="C2"
          ></e-column>
          <e-column
            field="pricechangeLog.effectiveStartDate"
            headerText="Start Date"
            textAlign="Left"
            width="120"
            type="date"
            format="MMM dd, yyyy"
          ></e-column>
          <e-column
            field="pricechangeLog.effectiveEndDate"
            headerText="End Date"
            textAlign="Left"
            width="120"
            type="date"
            format="MMM dd, yyyy"
          ></e-column>
        </e-columns>
      </ejs-grid>
    </div>

    <div style="margin: -12px;">
      <div tabindex="0"  id="basic">
       <div class="e-card-content">
          <ejs-tab
            id="productprices_tab"
            class="e-background"
            ref="refProductPricesTabInstance"
            enablePersistence="true"
            :selected="tabSelected"
            :selecting="tabSelect"
            :created="tabCreated"
          >
            <e-tabitems>
              <e-tabitem :header="headerText0" :content="content0"></e-tabitem>
              <e-tabitem :header="headerText1" :content="content1"></e-tabitem>
              <e-tabitem :header="headerText2" :content="content2"></e-tabitem>
              <e-tabitem :header="headerText3" :content="content3"></e-tabitem>
              <e-tabitem :header="headerText4" :content="content4"></e-tabitem>
            </e-tabitems>
          </ejs-tab>
        </div>
      </div>
    </div>
  </div>
  </div>
</template>

<script>
import Vue from 'vue';
import {
  GridPlugin,
  DetailRow,
  Page,
  CommandColumn,
  Sort,
} from '@syncfusion/ej2-vue-grids';
import { TabPlugin } from '@syncfusion/ej2-vue-navigations';
import { DateTimePicker } from '@syncfusion/ej2-vue-calendars';
import {
  FETCH_PERMIT_PRICES,
  FETCH_SEARCH_REQUEST_PRICES,
  FETCH_HISTORICAL_PRICES,
  FETCH_OPERATIONAL_PRICES,
  FETCH_MISCELLANEOUS_PRICES,
} from '../store';

Vue.use(GridPlugin);
Vue.use(TabPlugin);

export default {
  name: 'ManagePermitPrices',

  async created() {
    // await this.LoadData();
  },

  data() {
    return {
      headerText0: { text: 'Permit Prices' },
      headerText1: { text: 'Operational Permit Prices' },
      headerText2: { text: 'Search Request Prices' },
      headerText3: { text: 'Miscellaneous Prices' },
      headerText4: { text: 'Historical Prices' },
      content0: '#permitTab',
      content1: '#operationalTab',
      content2: '#searchrequestTab',
      content3: '#miscellaneousTab',
      content4: '#historicalTab',
      selectionOptions: {
        type: 'Single',
        enableSimpleMultiRowSelection: false,
        enableToggle: true,
        persistSelection: true,
      },
      pageSettings: { pageSize: 10 },
      commands: [
        {
          type: 'Edit',
          buttonOption: { cssClass: 'e-flat', iconCss: 'e-edit e-icons' },
        },
      ],
    };
  },
  computed: {},

  methods: {
    dataIsNotReady() {
      return this.$store.getters.permitPrices === null;
    },

    PermitPrices() {
      return this.$store.getters.permitPrices;
    },

    SearchRequestPrices() {
      return this.$store.getters.searchrequestPrices;
    },

    HistoricalPrices() {
      return this.$store.getters.historicalPrices;
    },
    MiscellaneousPrices() {
      return this.$store.getters.miscellaneousPrices;
    },

    OperationalPrices(i) {
      const operationals = this.$store.getters.operationalPrices;

      // eslint-disable-next-line max-len
      if (operationals == null || i >= operationals.length) {
        return [];
      }
      if (operationals[i].fees[0].opYear < new Date().getFullYear()) {
        return [];
      }
      return operationals[i].fees;
    },

    rowPriceDataBound(args) {
      if (args.data.beenEffective === true) {
        args.row.classList.add('effectiverow');
      }
    },

    async tabCreated() {
      // const tabObj = document.getElementById('productprices_tab');
      // tabObj.ej2_instances[0].select(1);
      const tabObj = this.$refs.refProductPricesTabInstance.ej2Instances;
      const tagId = tabObj.selectedID;
      if (tagId === '0') {
        await this.$store.dispatch(FETCH_PERMIT_PRICES);
      } else if (tagId === '1') {
        await this.$store.dispatch(FETCH_OPERATIONAL_PRICES);
      } else if (tagId === '2') {
        await this.$store.dispatch(FETCH_SEARCH_REQUEST_PRICES);
      } else if (tagId === '3') {
        await this.$store.dispatch(FETCH_MISCELLANEOUS_PRICES);
      } else if (tagId === '4') {
        await this.$store.dispatch(FETCH_HISTORICAL_PRICES);
      }
      // // After tab created first tab content and active line are
      // // hidden by adding custom class to make it collapse state
      // this.actLine = document.querySelector('.e-indicator');
      // // // document.getElementById('e-content_0').classList.add('collapse');
      // this.actLine.classList.add('collapse');
    },
    async tabSelect(e) {
      if (e.isSwiped) {
        e.cancel = true;
      }
    },
    async tabSelected(e) {
      const tagId = e.selectedIndex;
      if (tagId === 0) {
        await this.$store.dispatch(FETCH_PERMIT_PRICES);
      } else if (tagId === 1) {
        await this.$store.dispatch(FETCH_OPERATIONAL_PRICES);
      } else if (tagId === 2) {
        await this.$store.dispatch(FETCH_SEARCH_REQUEST_PRICES);
      } else if (tagId === 3) {
        await this.$store.dispatch(FETCH_MISCELLANEOUS_PRICES);
      } else if (tagId === 4) {
        await this.$store.dispatch(FETCH_HISTORICAL_PRICES);
      }
      // // If next tab item selected custom class is removed from content and active line element
      // const cnttrgs = document.querySelectorAll('#collapsible_tab.e-tab > .e-content > .e-item');
      // for (let i = 0; i < cnttrgs.length; i += 1) {
      //   cnttrgs[i].classList.remove('collapse');
      // }
      // if (this.actLine !== undefined) { this.actLine.classList.remove('collapse'); }
      // this.trgIndex = e.selectedIndex;
      // // Custom click event binding for each tab item to make collapse/expand
      // e.selectedItem.addEventListener('click', () => {
      //   this.updateCollapseClass(this.trgIndex);
      // });
    },
    cmdPermitClick(args) {
      if (args.commandColumn.type === 'Edit') {
        if (args.rowData.price == null) {
          // console.log('price cannot be NULL');
        } else {
          this.$router.push(
            `/products/addPermitprice/${args.rowData.price.priceId}`,
          );
        }
      }
    },
    cmdSearchRequestClick(args) {
      if (args.commandColumn.type === 'Edit') {
        if (args.rowData.price == null) {
          // console.log('price cannot be NULL');
        } else {
          this.$router.push(
            `/products/searchrequestprice/${args.rowData.price.priceId}`,
          );
        }
      }
    },
    cmdMiscellaneousClick(args) {
      if (args.commandColumn.type === 'Edit') {
        if (args.rowData.price == null) {
          // console.log('price cannot be NULL');
        } else {
          this.$router.push(
            `/products/addmiscellaneousprice/${args.rowData.price.priceId}`,
          );
        }
      }
    },
    onNewPermitPriceClick() {
      this.$router.push('/products/addPermitprice/0');
    },
    onNewSearchRequestPriceClick() {
      this.$router.push('/products/searchrequestprice/0');
    },
    onNewMiscellaneousPriceClick() {
      this.$router.push('/products/addmiscellaneousprice/0');
    },
  },

  provide: {
    grid: [DetailRow, Page, CommandColumn, Sort],
  },
};
</script>

<style>
@import "../../../assets/styles/eservices-base.css";

tr.effectiverow button.e-btn {
  display: none;
}

span.e-headertext {
  font-weight: bold;
  font-size: 14px;
}

th.e-headercell {
  background-color: aqua;
}
.e-card-content {
  margin: 0% !important;
}
.container_price {
  padding: 10px 10px 10px 10px;
}
</style>
